module.exports = __webpack_public_path__ + "img/ico-like_active.d79be176.svg";